import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import MaterialFormControlLabel from "../../../../__snowpack__/pkg/@mui/material/FormControlLabel.js";
import {Field} from "../../../../__snowpack__/pkg/formik.js";
import React, {useCallback, useMemo} from "react";
import {cmpClassName, getRandomString} from "../../../common/generic-react.functions.js";
import Icon from "../icon/icon.component.js";
import {RadioContainer} from "./radio.styles.js";
function Radio({
  children,
  dataCy,
  translate,
  label,
  labelPlacement = "end",
  name,
  color = "secondary",
  disabled,
  readOnly,
  size,
  icon,
  checkedIcon,
  value = "",
  onChange
}) {
  const {
    t
  } = useTranslation();
  const _dataCy = useMemo(() => dataCy || translate || children, [children, dataCy, translate]);
  const text = useMemo(() => translate ? t(translate) : label || children || "", [children, label, t, translate]);
  const itemName = useMemo(() => name || getRandomString(), [name]);
  const itemId = useMemo(() => `${name || "unnamed"}__${getRandomString()}`, [name]);
  const ItemIcon = useMemo(() => icon || /* @__PURE__ */ React.createElement(Icon, null, "radio_button_unchecked"), [icon]);
  const ItemCheckedIcon = useMemo(() => checkedIcon || /* @__PURE__ */ React.createElement(Icon, null, "radio_button_checked"), [checkedIcon]);
  const handleChange = useCallback((event, checked, field) => {
    if (!disabled) {
      field?.onChange(event);
      if (onChange) {
        onChange(event, checked);
      }
    }
  }, [disabled, onChange]);
  const RadioComponent = useCallback(({
    field
  }) => /* @__PURE__ */ React.createElement(MaterialFormControlLabel, {
    disabled,
    "aria-readonly": readOnly,
    control: /* @__PURE__ */ React.createElement(RadioContainer, {
      "data-cy": _dataCy,
      className: cmpClassName("radio"),
      readOnly,
      id: itemId,
      name: itemName,
      checked: field.value === value,
      color,
      size,
      icon: ItemIcon,
      checkedIcon: ItemCheckedIcon,
      value,
      onChange: (e, checked) => handleChange(e, checked, field)
    }),
    label: text,
    labelPlacement
  }), [ItemCheckedIcon, ItemIcon, _dataCy, color, disabled, handleChange, itemId, itemName, labelPlacement, readOnly, size, text, value]);
  return /* @__PURE__ */ React.createElement(Field, {
    name: itemName,
    component: RadioComponent
  });
}
export default /* @__PURE__ */ React.memo(Radio);
